<ng-template #modal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Proceso de validación</h4>
        <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="btn-close" type="button"></button>
    </div>
    <div class="modal-body">
        <div class="form-group my-3">
            <label class="mb-1">{{ isPolicyOwner
              ? 'Se le ha enviado un código de confirmación al correo. Por favor introducirlo debajo'
              : "Se le ha enviado un código de confirmación a su correo y al correo del titular de la póliza. Por favor introducirlo debajo"}}</label>
            <input [(ngModel)]="code" class="form-control" type="text" />
        </div>
        <div class="d-flex justify-content-between align-items-center flex-column gap-2">
          @if(timerRunning){
            <span>Debe esperar {{ timer }} segundo{{timer > 1 ? 's' : ''}} para poder reenviar</span>
          }
          <button (click)="sendOTP()" [disabled]="timerRunning" class="btn btn-outline-secondary">Reenviar código</button>
        </div>
    </div>
    <div class="modal-footer">
        <button (click)="validateCode()" class="btn btn-danger bg-colonial" type="button">Validar</button>
    </div>
</ng-template>
